if (!window.SolyraQuickViewReady) {
  window.SolyraQuickViewReady = true;

  const syncQuickViewScrollLock = () => {
    const hasOpenScrollLockDialog = Boolean(document.querySelector('dialog[scroll-lock][open]'));
    document.documentElement.classList.toggle('dialog-scroll-locked', hasOpenScrollLockDialog);
  };

  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const motionDuration = (name, fallback) => {
    const value = window.getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    if (!value) return fallback;
    const parsed = Number.parseFloat(value);
    if (!Number.isFinite(parsed)) return fallback;
    return value.endsWith('ms') ? parsed : parsed * 1000;
  };

  const openMotionDialog = (dialog) => {
    if (!dialog || typeof dialog.showModal !== 'function') return;

    if (prefersReducedMotion()) {
      dialog.showModal();
      return;
    }

    dialog.setAttribute('data-opening', '');
    dialog.showModal();
    requestAnimationFrame(() => dialog.removeAttribute('data-opening'));
  };

  const closeMotionDialog = (dialog) => {
    if (!dialog || !dialog.open) return;

    if (prefersReducedMotion()) {
      dialog.close();
      return;
    }

    dialog.setAttribute('data-closing', '');
    window.setTimeout(() => {
      if (dialog.open) dialog.close();
    }, motionDuration('--motion-duration-overlay', 320));
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-quick-view-open]');
    const closeButton = event.target.closest('[data-quick-view-close]');

    if (openButton) {
      const card = openButton.closest('.product-card');
      const dialog =
        card?.querySelector('[data-quick-view-dialog]') ||
        document.getElementById(openButton.getAttribute('aria-controls'));

      if (dialog && typeof dialog.showModal === 'function') {
        if (dialog.parentElement !== document.body) {
          document.body.append(dialog);
        }

        dialog.solyraQuickViewTrigger = openButton;
        openMotionDialog(dialog);
        syncQuickViewScrollLock();

        window.requestAnimationFrame(() => {
          const initialFocusTarget = dialog.querySelector(
            '[data-quick-view-initial-focus], button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
          );

          initialFocusTarget?.focus({ preventScroll: true });
        });
      }
    }

    if (closeButton) {
      closeMotionDialog(closeButton.closest('[data-quick-view-dialog]'));
    }
  });

  document.addEventListener('click', (event) => {
    if (event.target.matches('[data-quick-view-dialog]')) {
      closeMotionDialog(event.target);
    }
  });

  document.addEventListener('close', (event) => {
    if (event.target.matches('[data-quick-view-dialog]')) {
      event.target.removeAttribute('data-opening');
      event.target.removeAttribute('data-closing');
      syncQuickViewScrollLock();

      const trigger = event.target.solyraQuickViewTrigger;
      if (trigger instanceof HTMLElement && document.contains(trigger)) {
        trigger.focus({ preventScroll: true });
      }

      event.target.solyraQuickViewTrigger = null;
    }
  }, true);

  document.addEventListener('cancel', (event) => {
    if (event.target.matches('[data-quick-view-dialog]')) {
      if (prefersReducedMotion()) {
        window.requestAnimationFrame(syncQuickViewScrollLock);
        return;
      }

      event.preventDefault();
      closeMotionDialog(event.target);
    }
  }, true);

  document.addEventListener('submit', (event) => {
    // Quick add intentionally uses Shopify's native cart form POST.
    // This handler only prevents repeat submissions while the browser navigates.
    const form = event.target.closest('.product-card__quick-add-form');

    if (!form) {
      return;
    }

    const button = form.querySelector('button[type="submit"]');
    const label = button?.querySelector('[data-quick-add-label]');

    if (!button || !label) {
      return;
    }

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    label.textContent = button.dataset.loadingLabel || label.textContent;
  });
}
